import axios from 'axios';

const api = axios
	.create({
		baseURL: process.env.VUE_APP_API_URL,
		handlerEnabled: false,
	});


const TOKENS_STORAGE_KEY = 'tokens';

api.interceptors.request.use((config) => {
	if (localStorage.getItem(TOKENS_STORAGE_KEY) !== null) {
		const token = JSON.parse(localStorage.getItem(TOKENS_STORAGE_KEY));
		// eslint-disable-next-line no-param-reassign
		config.headers.Authorization = `${token.tokenType} ${token.jwtToken}`;
	}

	return config;
});

export default api;
